import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction, useRef } from "react";
import { FormProvider, useForm } from "react-hook-form";
import Select from "react-select";
import UnForm from "../../../../../Components/Form";
import StickyToolbar from "../../../../../Components/StickyToolbar";
import { useUserInfor } from "../../../../../Context/User";
import { ListarEtapasRepasseController } from "../../../../../Controllers/Geral/Etapas/EtapasControllers";
import { ListarCategoriaRepasseController } from "../../../../../Controllers/Geral/GestaoDeCadastros/CategoriaAtendimento";
import { ListarUsuariosController } from "../../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { ListarEmpreendimentosController } from "../../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { GetOrigemLeadController } from "../../../../../Controllers/Repasse/OrigemLeadRepasse/OrigemLeadRepasseControllers";
import { ListarEquipesDeVendasController } from "../../../../../Controllers/Vendas/EquipeVendas/EquipeVendasControllers";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { TModoGestaoAtendimento } from "../../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import { IAtendimentoRepasseRequest } from "../../../../../Interfaces/Repasse/AtendimentosRepasse/AtendimentosRepasse";
import StorageManagerCapys from "../../../../../Tools/Storage";
import { formatterCPF_CNPJ } from "../../../../../Validations/InputMasks";
import { ListarCanalAtendimentoContoller } from "../../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import useAtendimentoRepasse from "../useAtendimentoRepasse";
// import { Switch } from "../../../../../Components/CardsPages/Forms/Switch";
// import Swal from "sweetalert2";

interface IFiltroAtendimentosRepasseProps {
    handleSubmit: (filter: IAtendimentoRepasseRequest) => void;
    defaultFilter?: IAtendimentoRepasseRequest;
    atendimento: TModoGestaoAtendimento;
    setIdEmpreendimentoOption: Dispatch<
        SetStateAction<{ label: string; value: number }[] | null>
    >;
    idEmpreendimentoOption?:
        | {
              label: string;
              value: number;
          }[]
        | null;
    // setNaoContem: Dispatch<SetStateAction<boolean>>;
    filtroGestaoStorage: StorageManagerCapys<IAtendimentoRepasseRequest>;
}

export default function FiltroAtendimentosRepasse(
    props: IFiltroAtendimentosRepasseProps
) {
    const filter = props.defaultFilter;
    const hadleFilterFormSubmit = props.handleSubmit;
    const FormMethods = useForm();
    const { reset, control, setValue } = FormMethods;
    const { UserInfor } = useUserInfor();

    const { filtroInicial } = useAtendimentoRepasse(props.atendimento);

    const selectInputRef = useRef<any>();

    const limparFiltros = () => {
        selectInputRef.current?.clearValue();
    };

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const { execute: listarCanalAtendimento } = useAsyncCallback(
        () => ListarCanalAtendimentoContoller(),
        []
    );

    const { value: listarEmpreendimentos } = useAsyncEffect(
        () => ListarEmpreendimentosController(),
        []
    );

    const lstEmpreendimentosOptions = listarEmpreendimentos?.map((e) => ({
        label: e.DS_EMPREENDIMENTO,
        value: e.ID_EMPREENDIMENTO,
    }));

    return (
        <StickyToolbar active={!!props.filtroGestaoStorage.get()}>
            <FormProvider {...FormMethods}>
                <UnForm
                    handleSubmit={hadleFilterFormSubmit}
                    className="form-group row"
                    usingContext
                >
                    <div className="col-12 mt-3">
                        <label>Data Inicial</label>
                        <div className="row">
                            <div className="col-6">
                                <UnForm.Input
                                    className="form-control"
                                    type="date"
                                    defaultValue={filter?.DT_INICIAL_IN}
                                    name="DT_INICIAL_IN"
                                />
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    className="form-control"
                                    type="date"
                                    defaultValue={filter?.DT_INICIAL_FN}
                                    name="DT_INICIAL_FN"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mt-3">
                        <label>Data Final</label>
                        <div className="row">
                            <div className="col-6">
                                <UnForm.Input
                                    className="form-control"
                                    type="date"
                                    defaultValue={filter?.DT_FINAL_IN}
                                    name="DT_FINAL_IN"
                                />
                            </div>
                            <div className="col-6">
                                <UnForm.Input
                                    className="form-control"
                                    type="date"
                                    defaultValue={filter?.DT_FINAL_FN}
                                    name="DT_FINAL_FN"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mt-3">
                        <label>Status do Caso</label>
                        <UnForm.Select
                            className="form-control"
                            name="DS_STATUS_CASO"
                            defaultValue={filter?.DS_STATUS_CASO ?? "Aberto"}
                        >
                            <option></option>
                            <option>Aberto</option>
                            <option>Fechado</option>
                        </UnForm.Select>
                    </div>
                    <div className="col-12 mt-3">
                        <label>CPF/CNPJ</label>
                        <UnForm.Input
                            className="form-control"
                            type="text"
                            maxLength={18}
                            name="NR_CPF"
                            {...FormMethods}
                            onChange={formatterCPF_CNPJ}
                            wrapperClassName="col-12 col-md-6 mt-3"
                            defaultValue={filter?.NR_CPF}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <label>Empreendimento</label>
                        <Select
                            name="ID_EMPREENDIMENTO"
                            ref={selectInputRef}
                            options={lstEmpreendimentosOptions}
                            value={props.idEmpreendimentoOption}
                            isClearable
                            isMulti
                            onChange={(e) => {
                                props.setIdEmpreendimentoOption(
                                    e.map((value) => ({
                                        label: value.label,
                                        value: value.value,
                                    }))
                                );
                            }}
                            components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                            }}
                            styles={customStyles}
                            placeholder={""}
                            noOptionsMessage={() => "Sem opções"}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <label>Protocolo</label>
                        <UnForm.Input
                            className="form-control"
                            type="number"
                            name="ID_CASO"
                            defaultValue={filter?.ID_CASO}
                        />
                    </div>
                    {props.atendimento === "GRUPO" &&
                        UserInfor.FUNCOES.some(
                            (f) => f.NM_FUNCAO === "ADM_GESTAO_CASO_GRUPO"
                        ) && (
                            <div className="col-12 mt-3">
                                <label>Situação</label>
                                <UnForm.Select
                                    className="form-control"
                                    name="FL_ANDAMENTO"
                                    defaultValue={filter?.FL_ANDAMENTO}
                                >
                                    <option value={2}>Todos</option>
                                    <option value={1}>Em Atendimento</option>
                                    <option value={0}>
                                        Fila de Atendimento
                                    </option>
                                </UnForm.Select>
                            </div>
                        )}
                    {props.atendimento !== "USUARIO" && (
                        <div className="col-12 mt-3">
                            <label>Atendente</label>
                            <UnForm.LazySelect
                                className="form-control"
                                name="ID_USUARIO"
                                controller={ListarUsuariosController}
                                filter={(u) => u.FL_ATIVO}
                                getDS={(u) => u.DS_NOME}
                                getKeyValue={(u) => u.ID_USUARIO}
                                defaultValue={filter?.ID_USUARIO}
                                setValue={setValue}
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>
                    )}
                    <div className="col-12 mt-3">
                        <label>Cliente</label>
                        <UnForm.Input
                            className="form-control"
                            type="text"
                            name="DS_NOME_CONTA"
                            defaultValue={filter?.DS_NOME_CONTA}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <label>Contato</label>
                        <UnForm.Input
                            className="form-control"
                            type="text"
                            name="DS_NOME_CONTATO"
                            defaultValue={filter?.DS_NOME_CONTATO}
                        />
                    </div>

                    <div className="col-12 mt-3">
                        <UnForm.LazySelect
                            label={"Origem Lead"}
                            className={`form-control placeholder-dark-75`}
                            name="ID_ORIGEM_LEAD"
                            registerOptions={{
                                valueAsNumber: true,
                            }}
                            {...FormMethods}
                            defaultValue={filter?.ID_ORIGEM_LEAD}
                            controller={GetOrigemLeadController}
                            getDS={(s) => s.DS_ORIGEM_LEAD}
                            getKeyValue={(s) => s.ID_ORIGEM_LEAD}
                        >
                            <option value={0}></option>
                        </UnForm.LazySelect>
                    </div>

                    <div className="col-12 mt-3">
                        <UnForm.LazySelect
                            label={"Equipe Vendas"}
                            className={`form-control placeholder-dark-75`}
                            name="ID_EQUIPE_VENDAS"
                            registerOptions={{
                                valueAsNumber: true,
                            }}
                            {...FormMethods}
                            defaultValue={filter?.ID_EQUIPE_VENDAS}
                            controller={ListarEquipesDeVendasController}
                            getDS={(s) => s.DS_EQUIPE_VENDAS}
                            getKeyValue={(s) => s.ID_EQUIPE_VENDAS}
                        >
                            <option value={0}></option>
                        </UnForm.LazySelect>
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.LazySelect
                            label="Categoria de Atendimento"
                            name="ID_CATEGORIA_ATENDIMENTO"
                            registerOptions={{
                                valueAsNumber: true,
                            }}
                            {...FormMethods}
                            //ALTERAR
                            controller={ListarCategoriaRepasseController}
                            getDS={(s) => s.DS_CATEGORIA_ATENDIMENTO}
                            getKeyValue={(s) => s.ID_CATEGORIA_ATENDIMENTO}
                        >
                            <option value={0}></option>
                        </UnForm.LazySelect>
                    </div>

                    <div className="col-12 mt-3">
                        <label>Etapa</label>
                        <UnForm.LazySelect
                            controller={ListarEtapasRepasseController}
                            getDS={(e) =>
                                e.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                            }
                            getKeyValue={(e) =>
                                e.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                            }
                            fatherName="ID_CATEGORIA_ATENDIMENTO"
                            name="ID_ETAPA_CATEGORIA_ATENDIMENTO"
                            control={control}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                    <div className={`col-12 mt-3 `}>
                        <UnForm.LazySelect
                            wrapperClassName="p-2 col-12 mb-3"
                            {...FormMethods}
                            defaultValue={filter?.ID_TIPO_CANAL_ATENDIMENTO}
                            className="mb-4"
                            label="Canal de Atendimento"
                            name="ID_TIPO_CANAL_ATENDIMENTO"
                            controller={listarCanalAtendimento}
                            getKeyValue={(u) => u.ID_TIPO_CANAL_ATENDIMENTO}
                            getDS={(u) => u.DS_TIPO_CANAL_ATENDIMENTO}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                    {/* <div className={`col-12 mt-3 `}>
                        <label>Não contém</label>
                        <div className="d-flex justify-content-start">
                            <Switch
                                color="success"
                                labelPosition="top"
                                type="checkbox"
                                name="FL_CONTEM"
                                onChange={(e) => {
                                    if (e.target.checked === true) {
                                        Swal.fire({
                                            title: "Ao ativar a opção 'Não Contém', sua pesquisa retornará todos os registros que não têm o texto especificado.",
                                            icon: "info",
                                            buttonsStyling: false,
                                            confirmButtonText:
                                                "<i class='la la-check'></i> Ok!",
                                            customClass: {
                                                confirmButton:
                                                    "btn btn-outline-success",
                                            },
                                        });
                                        props.setNaoContem(false);
                                    } else {
                                        props.setNaoContem(true);
                                    }
                                }}
                                defaultChecked={false}
                            />
                        </div>
                    </div> */}
                    <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                        <button
                            type="submit"
                            className="btn btn-block btn-outline-dark mt-2"
                        >
                            <FontAwesomeIcon icon={faFilter} className="mr-2" />
                            Filtrar
                        </button>
                    </div>
                    <div className="col-12 d-flex align-items-end justify-content-start">
                        <button
                            type="button"
                            onClick={() => {
                                props.filtroGestaoStorage.remove();
                                reset(filtroInicial);
                                limparFiltros();
                            }}
                            className="btn btn-block btn-outline-danger mt-2"
                        >
                            <FontAwesomeIcon icon={faTimes} className="mr-2" />
                            Limpar Filtros
                        </button>
                    </div>
                </UnForm>
            </FormProvider>
        </StickyToolbar>
    );
}
